import React from "react";
import InlineSVG from "react-inlinesvg";

class CustomInlineSvg extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialState: {
                cacheRequests: true,
                uniqueHash: 'r8e1a9c5',
                uniquifyIDs: true
            }
        }
    }

    render() {
        const {svgProps, scale, fill} = this.props;
        const {initialState} = this.state;
        let props = Object.assign(initialState, svgProps ? svgProps : {})
        return (
            <InlineSVG
                {...props}
                style={{transform: scale ? `scale(${scale})` : 'scale(1)', fill: fill ? fill : 'none'}}
            />
        )
    }
}

export default CustomInlineSvg;